import moment from 'moment'

const ChatMessage = (props) => {
    var message = ``;

    const separators = ["\\{", "\\}"];
    const separatorsMsg = props.item.msg_body.split(
        new RegExp(separators.join("|"), "g")
    );
    
    separatorsMsg.filter((value1) => {
        if (value1.search("value") >= 0 && value1.search("type") >= 0) {
            const parseButton = JSON.parse(" { " + value1 + " } ");
            var button = `<button className="btn btn-sm" style="background-color: ${parseButton.bg_color}; color: ${parseButton.text_color}; margin-right: 5px;">${parseButton.label}</button>`;

            message += button;
        } else if (value1.search("link") >= 0 && value1.search("type") >= 0) {
            const parseLink = JSON.parse(" { " + value1 + " } ");

            var link = `<a href="${parseLink.link}" className="opacity-75-hover test-primary me-1" target="_blank" style="word-break: break-all">${parseLink.name}</a>`
            message += link;
        } else if (value1.search("video_url") >= 0 && value1.search("type") >= 0) {
            const parseVideoUrl = JSON.parse(" { " + value1 + " } ");

            var videoSourceDiv = `<video width="200" height="100" controls><source src="${parseVideoUrl.video_url}" type="video/mp4" /></video>`;

            message += videoSourceDiv;
        } else if (value1.search("audio_url") >= 0 && value1.search("type") >= 0) {
            const parseAudioUrl = JSON.parse(" { " + value1 + " } ");

            var audioSourceDiv = `<audio style="width: 290px;" controls><source src="${parseAudioUrl.audio_url}" type="audio/mpeg" /></audio>`;

            message += audioSourceDiv;
        } else {
            if(value1 != '' && value1 != ' '){
                var normal_text = `<div className="rounded bg-light-info text-dark fw-semibold mw-lg-400px text-start">${value1}</div>`;

                message += normal_text;
            }
        }
    });

    return (
        <div>
            <div className='row border-bottom'>
                <div className='col-md-7'>
                    {props.item.sender_id != props.chat_cession.sender_id &&<div className="d-flex justify-content-start mb-5 mt-5">
                        <div className="d-flex flex-column align-items-start">
                            <div className="d-flex align-items-center mb-2">
                                <div className="symbol symbol-35px symbol-circle">
                                    <img alt="Pic" src="/media/avatars/300-1.jpg" />
                                </div>
                                <div className="ms-3">
                                    <a href="#" className="fs-5 fw-bold text-gray-900 text-hover-primary me-1">Our Bot</a>
                                    <span className="text-muted fs-7 mb-1">{moment(props.item.created_at).format("D MMM YYYY, H:mm")}</span>
                                </div>
                            </div>
                            <div className="p-3 rounded bg-light-info text-dark fw-semibold mw-lg-400px text-start">
                                <div dangerouslySetInnerHTML={{ __html: message }} />
                            </div>
                        </div>
                    </div>}
                    {props.item.sender_id == props.chat_cession.sender_id && <div className="d-flex justify-content-end mb-5 mt-5">
                        <div className="d-flex flex-column align-items-end">
                            <div className="d-flex align-items-center mb-2">
                                <div className="me-3">
                                    <span className="text-muted fs-7 mb-1">{moment(props.item.created_at).format("D MMM YYYY, H:mm")}</span>
                                    <a href="#" className="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">{props.front_user}</a>
                                </div>
                                <div className="symbol symbol-35px symbol-circle">
                                    <img alt="Pic" src="/media/avatars/blank.png" />
                                </div>
                            </div>
                            <div className="p-3 rounded bg-light-primary text-dark fw-semibold mw-lg-400px text-end">
                                <div dangerouslySetInnerHTML={{ __html: message }} />
                            </div>
                        </div>
                    </div>}
                </div>
                <div className='col-md-5'>
                    <div className="d-flex justify-content-between pt-3">
                        <span className="fw-bold text-gray-600 fs-6">{props.item.indent}</span>
                        <span className="fw-bold text-gray-600 fs-6">{props.item.conversation_entity}</span>
                        <span className="fw-bold text-gray-600 fs-6">{props.item.information}</span>
                        <span className="fw-bold text-gray-600 fs-6">{props.item.action}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChatMessage;